module.exports = __webpack_public_path__ + "profile-title-bg.82ffe6e3195c200ce501.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/assets/corporate/img/profile-title-bg.jpg
// module id = ../../../../../src/assets/corporate/img/profile-title-bg.jpg
// module chunks = styles